import admin from './handle'
 
export const AdminService     = admin